document.body.addEventListener("click", (event) => {
    setTimeout(() => {
        let target;
        if ((target = event.target.closest(".Video__PlayButton"))) {
            const controledModal = document.querySelector(
                `#${target.getAttribute("aria-controls")}`,
            );
            const video = controledModal.querySelector("video");
            video.play();
            const stopVideo = () => {
                video.pause();
                video.currentTime = 0;
                controledModal.removeEventListener("dialog:before-hide", stopVideo);
            };
            controledModal.addEventListener("dialog:before-hide", stopVideo);
        }
    });
});

try {
    (() => {
        // Installment messaging cleanup (HC) - 2026-06-09 v7. FREEZE-SAFE: no MutationObserver.
        //   Shop Pay: keep Shopify's native line, trimming only the redundant lead-in so it reads
        //     "or from $X/mo with Shop Pay" (higher-priced). Lower-priced items have no monthly plan and
        //     render "Pay in 4 ... of $X with Shop Pay"; left as-is. Shop Pay updates its own amount.
        //   Afterpay: rewrite the .afterpay-text1 span to "Pay in 4 ... of $X with", AND keep $X in sync
        //     with the selected variant via window.__hcInstallments (emitted by snippets/afterpay.liquid).
        //     Afterpay's own widget renders a static load-time amount, so we drive it ourselves.
        // Mechanism: a SHORT, BOUNDED burst (normalize ~10x over ~4s on load + once on variant change).
        // Never reacts to Shopify's own mutations -> cannot enter the re-render war that FROZE the Astra
        // PDP under the old observer. See feedback_no_observer_on_shopify_payment_terms.
        var CSS = "\n            #shopify-installments { display: flex; flex-direction: row; flex-wrap: wrap; align-items: center; justify-content: center; gap: 4px; font-family: 'Lato' !important; font-size: 12px; }\n            @media (min-width: 768px) { #shopify-installments { justify-content: flex-start; } }\n            #shopify-installments p { margin: 0; display: inline-flex; flex-wrap: wrap; align-items: center; gap: 4px; }\n            .font-bold { font-weight: normal !important; }\n            button#shopify-installments-cta { font-size: 0; text-decoration: none; color: #000000; }\n            button#shopify-installments-cta::before { content: '\u24d8'; font-size: 11px; }\n        ";

        function styleOnce(sr) {
            if (sr.querySelector('style[data-hc-installments]')) return;
            var s = document.createElement('style');
            s.setAttribute('data-hc-installments', '');
            s.textContent = CSS;
            sr.appendChild(s);
        }

        function standardizeShopPay() {
            var el = document.querySelector('shopify-payment-terms');
            var sr = el && el.shadowRoot;
            if (!sr) return;
            styleOnce(sr);
            var content = sr.querySelector('#shopify-installments-content');
            if (!content) return;
            content.childNodes.forEach(function (node) {
                if (node.nodeType === 3 && /interest-free installments/i.test(node.textContent) && /\bor\s+from\b/i.test(node.textContent)) {
                    node.textContent = node.textContent.replace(/^[\s\S]*?\bor\s+from\s*/i, 'or from ');
                }
            });
        }

        // Currently-selected variant id. On the product page Prestige keeps ?variant in the URL in sync
        // with the picker (update_url), so that's the most reliable source; fall back to the form input.
        function selectedVariantId() {
            try { var u = new URL(location.href).searchParams.get('variant'); if (u) return u; } catch (e) {}
            var input = document.querySelector('[name="id"]');
            if (input && input.value) return input.value;
            var spt = document.querySelector('shopify-payment-terms');
            if (spt && spt.getAttribute('variant-id')) return spt.getAttribute('variant-id');
            return null;
        }

        function rewriteAfterpay(node) {
            var amt = null;
            var vid = selectedVariantId();
            if (window.__hcInstallments && vid && window.__hcInstallments[vid]) amt = window.__hcInstallments[vid];
            var t = node.textContent;
            var nt = t
                .replace(/\bor\s+4\s+interest-free\s+installments\s+of\b/i, 'Pay in 4 interest-free installments of')
                .replace(/\bby\s*$/i, 'with ');
            if (amt) nt = nt.replace(/\$[\d,]+(?:\.\d{1,2})?/, amt);
            if (nt !== t) node.textContent = nt;
        }

        function standardizeAfterpay() {
            // Primary: the text lives in a .afterpay-text1 span.
            document.querySelectorAll('.afterpay-text1').forEach(rewriteAfterpay);
            // Fallback: direct text nodes of .afterpay-paragraph (in case markup changes).
            document.querySelectorAll('.afterpay-paragraph').forEach(function (p) {
                p.childNodes.forEach(function (node) {
                    if (node.nodeType === 3) rewriteAfterpay(node);
                });
            });
        }

        function normalizeOnce() {
            standardizeShopPay();
            standardizeAfterpay();
        }

        var burstTimer = null;
        function burst() {
            if (burstTimer) clearInterval(burstTimer);
            var n = 0;
            normalizeOnce();
            burstTimer = setInterval(function () {
                n++;
                normalizeOnce();
                if (n >= 10) { clearInterval(burstTimer); burstTimer = null; }
            }, 400);
        }

        if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', burst);
        } else {
            burst();
        }

        // Re-run after a variant selection (price change re-renders Shop Pay and should re-sync Afterpay).
        // Event-driven, not mutation-driven, so it never loops.
        document.addEventListener('change', function (e) {
            var t = e.target;
            if (t && t.closest && t.closest('variant-picker, .variant-picker')) burst();
        });
    })();
} catch (e) {
    console.error(e);
}